module.exports = __webpack_public_path__ + "img/disc.a2e20f7b.svg";